import { useCallback } from 'react';

import { Session } from '@/types/session.types';
import SettingsToggle from '../../controls/settings-toggle';
import { useAppDispatch } from '@/store/hooks';
import { saveWorkingProjectSessionByField } from '@/store/slices/project';
import { ESettingsAdvancedWidgetLabels } from '../../settings.types';

interface RedirectUrlDetailProps {
  session?: Session;
  disabled?: boolean;
}

const RedirectUrlDetail = ({ disabled = false, session }: RedirectUrlDetailProps) => {
  const dispatch = useAppDispatch();
  const customUrlEnabled = session?.custom_url_enabled || false;

  const handleToggle = useCallback(() => {
    if (!session) return;
    dispatch(
      saveWorkingProjectSessionByField({
        uuid: session.uuid,
        custom_url_enabled: !customUrlEnabled,
      })
    );
  }, [customUrlEnabled, dispatch, session]);

  return (
    <SettingsToggle
      label={ESettingsAdvancedWidgetLabels.REDIRECT_URL}
      value={customUrlEnabled}
      sKey="redirect"
      disabled={disabled}
      onToggle={handleToggle}
    />
  );
};

export default RedirectUrlDetail;
